
    <ng-container [ngSwitch]="entity.alert_log_type">
      <alert-generic-log-widget *ngSwitchDefault (widgetEvent)="forward($event)" [entity]="entity" [options]="options" [layout]="layout"></alert-generic-log-widget>
    </ng-container>

    